import React from 'react';
import { Button } from '@material-ui/core';
import DownloadforOfflineOutlined from '@mui/icons-material/DownloadForOfflineOutlined';

import Deed from 'entities/deed/model';
import { downloadFileFromApi } from 'utils/downloadFileFromApi';

interface Props {
  deed: Deed;
}

export const ExportAttendeesButton = ({ deed }: Props) => (
  <Button
    onClick={() => {
      downloadFileFromApi(`api/deeds/${deed.id}/volunteers`, 'volunteers.csv');
    }}
    role="button"
    tabIndex={0}
    title="Download attendees CSV file"
    endIcon={<DownloadforOfflineOutlined />}
  >
    Export
  </Button>
);
